import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpClientBaseService } from "./base/httpClientBase.service";
import { Observable } from "rxjs";
import { A3LCommonDataEntity } from "../models/a3LCommonDataEntity.model";

@Injectable()
export class A3LCommonService extends HttpClientBaseService {

    constructor(_http: HttpClient) {
        super(_http, '', '', false);
    }

    getSexTypes(): Observable<A3LCommonDataEntity[]> {
        return this.http.get<A3LCommonDataEntity[]>(`${this.getUrl()}/sextypes`);
    }

    getPersonTypes(): Observable<A3LCommonDataEntity[]> {
        return this.http.get<A3LCommonDataEntity[]>(`${this.getUrl()}/persontypes`);
    }

    getIdentificationTypes(): Observable<A3LCommonDataEntity[]> {
        return this.http.get<A3LCommonDataEntity[]>(`${this.getUrl()}/identificationtypes`);
    }

    getContributionTypes(): Observable<A3LCommonDataEntity[]> {
        return this.http.get<A3LCommonDataEntity[]>(`${this.getUrl()}/contributiontypes`);
    }
}
